import { render, staticRenderFns } from "./ThemeReadMoreModal.vue?vue&type=template&id=4a45b905&scoped=true"
import script from "./ThemeReadMoreModal.vue?vue&type=script&lang=js"
export * from "./ThemeReadMoreModal.vue?vue&type=script&lang=js"
import style0 from "./ThemeReadMoreModal.vue?vue&type=style&index=0&id=4a45b905&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a45b905",
  null
  
)

export default component.exports